// Production Order Lookup Service
// Calls the Django proxy to fetch production order info from Business Central

import apiClient from './apiClient';

/**
 * Fetch production order info by any supported filter.
 * @param {Object} params - Query params: { serialNo, prodOrderNo, itemNo }
 * @returns {Promise<{success: boolean, data: object|null}>}
 */
export async function fetchProdOrderInfo(params = {}) {
  const query = new URLSearchParams();
  if (params.serialNo) query.set('serialNo', params.serialNo);
  if (params.prodOrderNo) query.set('prodOrderNo', params.prodOrderNo);
  if (params.itemNo) query.set('itemNo', params.itemNo);

  const response = await apiClient.get(
    `/api/frontend/prod-order-lookup/?${query.toString()}`
  );
  return response.json();
}

/**
 * Look up production order by serial number.
 * Returns { prodOrderNo, itemNo, serialNo } or null if not found.
 * Never throws — returns null on any failure so the scan flow is not blocked.
 */
export async function lookupBySerialNo(serialNo) {
  try {
    const result = await fetchProdOrderInfo({ serialNo });
    if (result.success && result.data) {
      return result.data;
    }
    return null;
  } catch (err) {
    console.warn('Production order lookup failed:', err);
    return null;
  }
}
